import React from "react";

const Link = ({ className, href, children }) => {
    
    const onClick = (event) => {
        // prevent full page reload
        event.preventDefault();
        // update url
        window.history.pushState({}, "", href);

        // communicate to Routes that URL has changed
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
        const navEventForHeader = new PopStateEvent('popstateBackgroundImage');
        window.dispatchEvent(navEventForHeader);
        
    };
  
   return (
    <a className={className} href={href} onClick={onClick}>
      {children}
    </a>
  );
};

export default Link;